module.exports = "<p>\n  <span [innerHTML]=\"textoActual\">\n  </span>\n  <a [class.hidden]=\"ocultar\" (click)=\"mostrar()\">{{ colapsado ? 'Mostrar más' : '' }}</a>\n  </p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/mostrar-mas/mostrar-mas.component.html
// module id = ./src/app/ui/mostrar-mas/mostrar-mas.component.html
// module chunks = main